export function customerRequiredFieldsSet(customerCollabInputs: any): boolean {
  if (!customerCollabInputs) return false;
  if (customerCollabInputs?.title && customerCollabInputs?.purpose && customerCollabInputs?.deliverables && (customerCollabInputs?.paymentAmount || customerCollabInputs?.otherComp)) return true;
  else return false;
}

export function hasAnyCustomerDetailsAdded(customerCollabInputs: any, countTitle: boolean): boolean {
  if (customerCollabInputs?.title && countTitle) {
    return true;
  } else if (
    customerCollabInputs?.purpose ||
    customerCollabInputs?.deliverables ||
    customerCollabInputs?.paymentAmount ||
    /* customerCollabInputs?.otherComp ||
    customerCollabInputs?.activityDate ||
    customerCollabInputs?.dueDate ||*/
    customerCollabInputs?.otherNotes
  )
    return true;
  else return false;
}
